module.exports = __webpack_public_path__ + "img/reference41.6c2c2146.jpg";